import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useRef } from 'react';

export const AbvGtnSalesPerspective = () => {

const entityPerspectiveRef = useRef();

const views = [
    {
      name: 'GTN Sales',
      dims: ['PAID_PERIOD', 'COMPANY_CODE', 'PROD', 'CHANNEL'],
      kpis: ['GROSS_SALES', 'REBATES', 'CONTRA_RECEIVABLES', 'DSA', 'OTHER_REVENUE', 'DISCOUNT_TOTAL', 'NET_SALES'],
      dimToPeriodicities: {
        PAID_PERIOD: ['YEAR', 'QTR', 'MON']
      }
    }
];

const getContextMenuItems = (params) => {
  let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

  let discSubMenu = [
    {
      name: 'Rebate Payments',
      action: () => entityPerspectiveRef.current.navigateToViewer(params, 'REBATES', 'Rebate Payments'),
      icon: fas.faListUl
    } , {
      name: 'Contra Receivables Payments',
      action: () => entityPerspectiveRef.current.navigateToViewer(params, 'CONTRA_RECEIVABLES', 'Contra Receivables Payments'),
      icon: fas.faListUl
    } , {
      name: 'DSA Payments',
      action: () => entityPerspectiveRef.current.navigateToViewer(params, 'DSA', 'DSA Payments'),
      icon: fas.faListUl
    } , {
      name: 'Other Revenue Payments',
      action: () => entityPerspectiveRef.current.navigateToViewer(params, 'OTHER_REVENUE', 'Other Revenue Payments'),
      icon: fas.faListUl
    }
  ];

  contextMenus.push(
    {
      name: 'Gross Sales',
      action: () => entityPerspectiveRef.current.navigateToViewer(params, 'GROSS_SALES', 'Gross Sales'),
      icon: fas.faListUl
    }, {
      name: 'Discounts',
      subMenu: discSubMenu,
      icon: fas.faListUl
    } 
  );
  
  return contextMenus;
}

  return (
    <EntityPerspective 
     ref={entityPerspectiveRef} 
     views={views}
     gridOptions={{
       getContextMenuItems
     }}
     />
  )
}